<template>
    <div class="page-container">
        <el-card class="box-card">
            <el-form :inline="true" :model="queryParams" class="demo-form-inline">
                <el-form-item label="套餐名称">
                    <el-input clearable v-model="queryParams.packageName" placeholder="请输入套餐名称"></el-input>
                </el-form-item>
                <el-form-item label="套餐状态">
                    <el-select clearable v-model="queryParams.status" placeholder="请选择套餐状态">
                        <el-option label="启用" :value="0"></el-option>
                        <el-option label="停用" :value="1"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button icon="el-icon-search" type="primary" @click="btnSearch">查询</el-button>
                    <el-button icon="el-icon-refresh" @click="btnReset">重置</el-button>
                </el-form-item>
            </el-form>
        </el-card>
        <div style="height: 10px;"></div>
        <el-card class="box-card">
            <el-button type="success" icon="el-icon-plus" @click="handleAdd()" size="mini" plain>新增</el-button>
            <div style="height: 10px;"></div>
            <el-table :data="tableData" border style="width: 100%">
                <el-table-column type="index" label="编号" width="100"></el-table-column>
                <el-table-column prop="packageName" label="套餐名称"></el-table-column>
                <el-table-column prop="remark" label="备注"></el-table-column>
                <el-table-column prop="status" label="套餐状态" align="center" width="120">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.status === 0 ? 'success' : 'danger'">
                            {{ scope.row.status === 0 ? '启用' : '停用' }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="createTime" label="创建时间" width="180"></el-table-column>
                <el-table-column align="center" label="操作" width="150">
                    <template slot-scope="scope">
                        <el-button type="text" icon="el-icon-edit" @click="handleEdit(scope.row)">修改</el-button>
                        <el-button type="text" icon="el-icon-delete" @click="handleDelete(scope.row.id)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                style="margin-top:10px;"
                background
                layout="total, prev, pager, next"
                @current-change="currentChange"
                :total="total">
            </el-pagination>
        </el-card>

        <!-- 新增/编辑弹窗 -->
        <el-dialog
            :title="dialogTitle"
            :visible.sync="dialogVisible"
            width="60%"
            @close="closeDialog">
            <el-form :model="form" :rules="rules" ref="form" label-width="100px">
                <el-form-item label="套餐名称" prop="packageName">
                    <el-input v-model="form.packageName" placeholder="请输入套餐名称"></el-input>
                </el-form-item>

                <el-form-item label="权限菜单" prop="menuIds">
                    <el-tree
                        ref="menuTree"
                        :data="menuTreeData"
                        show-checkbox
                        node-key="id"
                        :props="treeProps"
                        :default-expanded-keys="expandedKeys"
                        :key="treeKey">
                    </el-tree>
                </el-form-item>

                <el-form-item label="备注">
                    <el-input
                        v-model="form.remark"
                        type="textarea"
                        placeholder="请输入备注信息"></el-input>
                </el-form-item>

                <el-form-item label="套餐状态">
                    <el-switch
                        v-model="form.status"
                        :active-value="0"
                        :inactive-value="1"
                        active-text="启用"
                        inactive-text="停用">
                    </el-switch>
                </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
                <el-button @click="closeDialog">取 消</el-button>
                <el-button type="primary" @click="btnSubmit('form')">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import {reqDeleteSysTenantPackage, reqInsertSysTenantPackage, reqListSysTenantPackage, reqUpdateSysTenantPackage} from "@/api/system/tenant_package";
import {reqListMenuTree} from "@/api/system/menu";

export default {
    name: 'tenant-package',
    async created() {
        await this.load();
        await this.loadMenuTree();
    },
    data() {
        return {
            queryParams: {
                currentPage: 1,
                pageSize: 10,
                packageName: '',
                status: ''
            },
            tableData: [],
            total: 0,
            dialogVisible: false,
            isEdit: false,
            form: {
                id: null,
                packageName: '',
                remark: '',
                status: '1'
            },
            menuTreeData: [],
            expandedKeys: [],
            checkedKeys: [],
            treeKey: 0,
            treeProps: {
                children: 'children',
                label: 'name'
            },
            rules: {
                packageName: [
                    { required: true, message: '请输入套餐名称', trigger: 'blur' },
                    { min: 2, max: 20, message: '套餐名称长度在2-20个字符', trigger: 'blur' }
                ]
            }
        }
    },
    computed: {
        dialogTitle() {
            return this.isEdit ? '编辑套餐' : '新增套餐';
        }
    },
    methods: {
        // 加载套餐列表
        async load() {
            try {
                this.loading = true;
                this.tableData=[];
                const data = await reqListSysTenantPackage(this.queryParams);
                this.tableData = data.records || [];
                this.total = data.total || 0;
            } catch (error) {
                console.error('加载套餐列表失败:', error);
                this.$message.error('加载套餐列表失败');
            } finally {
                this.loading = false;
            }
        },

        // 加载菜单树
        async loadMenuTree() {
            try {
                const response = await reqListMenuTree();
                this.menuTreeData = response || [];
            } catch (error) {
                console.error('加载菜单树失败:', error);
                this.$message.error('加载菜单树失败');
            }
        },

        // 查询按钮
        async btnSearch() {
            this.queryParams.currentPage = 1;
            await this.load();
        },

        // 重置按钮
        async btnReset() {
            this.queryParams = {
                currentPage: 1,
                pageSize: 10,
                packageName: '',
                status: ''
            };
            await this.load();
        },

        // 分页切换
        currentChange(num) {
            this.queryParams.currentPage = num;
            this.load();
        },

        // 新增
        handleAdd() {
            this.isEdit = false;
            this.form = {
                id: null,
                packageName: '',
                remark: '',
                status: '1'
            };
            this.checkedKeys = [];
            this.expandedKeys = [];
            this.treeKey++;
            this.dialogVisible = true;
            // 树重建后清除所有选中
            this.$nextTick(() => {
                if (this.$refs.menuTree) {
                    this.$refs.menuTree.setCheckedKeys([]);
                }
            });
        },

        // 编辑
        handleEdit(row) {
            this.isEdit = true;
            this.form = { ...row };
            // 如果menuIds是逗号分割的字符串，需要转换为数组
            let ids = [];
            if (typeof row.menuIds === 'string') {
                ids = row.menuIds.split(',').filter(id => id.trim() !== '');
            } else {
                ids = row.menuIds || [];
            }
            // 转为数字类型，确保与树节点的 node-key(id) 类型一致
            this.checkedKeys = ids.map(id => Number(id));
            this.expandedKeys = this.getExpandedKeys(this.menuTreeData);
            // 通过key强制重建树组件，解决el-dialog复用时不重渲染导致default-checked-keys不生效的问题
            this.treeKey++;
            this.dialogVisible = true;
            // 树重建后用setCheckedKeys设置选中项
            this.$nextTick(() => {
                if (this.$refs.menuTree) {
                    this.$refs.menuTree.setCheckedKeys(this.checkedKeys);
                }
            });
        },

        // 获取展开的节点
        getExpandedKeys(treeData, keys = []) {
            treeData.forEach(node => {
                keys.push(node.id);
                if (node.children && node.children.length > 0) {
                    this.getExpandedKeys(node.children, keys);
                }
            });
            return keys;
        },

        // 提交表单
        async btnSubmit(formName) {
            this.$refs[formName].validate(async (valid) => {
                if (valid) {
                    try {
                        // 只获取全选中的叶子节点，不包含半选中的父节点（避免下次编辑时父节点导致全部子节点被勾选）
                        const selectedMenuIds = this.$refs.menuTree.getCheckedKeys();
                        const menuIdsString = selectedMenuIds.join(',');
                        // 构建提交数据
                        const submitData = {
                            ...this.form,
                            menuIds: menuIdsString
                        };

                        if (this.isEdit) {
                            await reqUpdateSysTenantPackage(submitData);
                            this.$message.success('更新套餐成功');
                        } else {
                            await reqInsertSysTenantPackage(submitData);
                            this.$message.success('新增套餐成功');
                        }

                        this.closeDialog();
                        await this.load();
                    } catch (error) {
                        console.error('保存套餐失败:', error);
                        this.$message.error(error.message || '保存套餐失败');
                    }
                }
            });
        },

        // 删除
        handleDelete(id) {
            this.$confirm('此操作将永久删除该套餐, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                try {
                    await reqDeleteSysTenantPackage({ id });
                    this.$message.success('删除成功');
                    await this.load();
                } catch (error) {
                    console.error('删除套餐失败:', error);
                }
            }).catch(() => {
                this.$message.info('已取消删除');
            });
        },

        // 关闭对话框
        closeDialog() {
            this.dialogVisible = false;
            if (this.$refs.form) {
                this.$refs.form.clearValidate();
            }
        }
    }
}
</script>

<style scoped>
.page-container {
    padding: 20px;
}

.box-card {
    margin-bottom: 10px;
}

.demo-form-inline .el-form-item {
    margin-bottom: 10px;
    margin-right: 20px;
}
</style>
